import { render, staticRenderFns } from "./barrio.vue?vue&type=template&id=ea9b3a4e"
import script from "./barrio.vue?vue&type=script&lang=js"
export * from "./barrio.vue?vue&type=script&lang=js"
import style0 from "./barrio.vue?vue&type=style&index=0&id=ea9b3a4e&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports